import styled from '@emotion/styled';
import TabMUI from '@mui/material/Tab';

export const TabV2Styled = styled(TabMUI)`
  &.Mui-selected {
    color: ${({ theme }) => theme.palette.common.black};
  }
`;
